import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ProductDetailsMainSlider } from 'src/app/models/product-details-main-slider';
import { ProductDetailsThumbSlider } from 'src/app/models/product-details-thumb-slider';
import { ImgPreviewComponent } from '../img-preview/img-preview.component';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'calsoft-product-mobile-image',
  templateUrl: './product-mobile-image.component.html',
  styleUrls: ['./product-mobile-image.component.scss']
})
export class ProductMobileImageComponent implements OnInit {

  constructor( public dialog: MatDialog,) { }

  @Input()  name: any;
  @Input() imageList:any=[];
  public ProductDetailsThumbConfig: any = ProductDetailsThumbSlider;
  public ProductDetailsMainSliderConfig: any = ProductDetailsMainSlider;
  public activeSlide: any = 0;
  @Input() productDetailHeightMobile: any="-webkit-fill-available";
  @Input() productDetailWidthMobile: any="-webkit-fill-available";

  public serverPath7 = environment.commonImageApi+"catalog/product";

  @Input() image:any;
  @Input() commonImageApi:any;
  @Input() bigImage: string;
  ngOnInit(): void {

    if(this.imageList==null){
      this.imageList=[]
    }

   else if(this.imageList.length==1){
    this.customOptions.touchDrag=false;
    this.customOptions.mouseDrag=false;
    }
  }



  customOptions: any = {
    items: 1,
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    dots: true,
    nav: false,
    slideSpeed: 300,
  }

  imagePreview(images, index) {

    if (window.innerWidth > 1024) {
      const dialogRef = this.dialog.open(ImgPreviewComponent, {
        height:'700px',   width: '700px', data: { page: index, images: images }
      });
      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
  
      });

    } else if (window.innerWidth == 1024) {
      const dialogRef = this.dialog.open(ImgPreviewComponent, {
       height:'600px', width: '600px',data: { page: index, images: images }
      });
      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
  
      });

    }
    
    else{

      const dialogRef = this.dialog.open(ImgPreviewComponent, {
        minWidth: '100vw', height: '100vh', data: { page: index, images: images }
      });
      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
  
      });

    }

  }


}
